'use strict'

class GuiHelper {
    static getQuantityItemList() {
        if (window.innerWidth > 1080) {
            return 3
        } else {
            return 6
        }
    }
}

export default GuiHelper
